import { PreuvesVirementAdmin } from '../components/documents/PreuvesVirementAdmin';
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Calculator, FilePlus, Shield, Settings, Users, DollarSign, FileText, TrendingUp, Building2, Crown } from 'lucide-react';

import SepaCbPanel from '../components/paiementsCb/SepaCbPanel';
import GEDDossiers from '../components/GED/GEDDossiers';
import { NettoyageZeroPanel } from '../components/admin/NettoyageZeroPanel';
import NomenclatureManagement from './NomenclatureManagement';
import ActivitesACompleter from '../components/nomenclature/ActivitesACompleter';
import EnvoisAttestationsMO from '../components/admin/EnvoisAttestationsMO';
import DerogationsFtpe from '../components/admin/DerogationsFtpe';
import SuiviSignatures from '../components/admin/SuiviSignatures';
import CategoriesManagement from './CategoriesManagement';
import NomenclatureCollectionsManagement from './NomenclatureCollectionsManagement';
import EstimateursManagement from './EstimateursManagement';
import SouscriptionsValidation from '../components/SouscriptionsValidation';
import SouscriptionsListe from '../components/SouscriptionsListe';
import ParametresBATICO from './ParametresBATICO';
import AchatsEnAttente from '../components/AchatsEnAttente';
import GestionMembresCooper from '../components/GestionMembresCooper';
import AdminMembresCreation from '../components/AdminMembresCreation';
import GestionDispositifs from '../components/GestionDispositifs';
import GEDESS from '../components/GED/GEDESS';
import VideoManager from '../components/GED/VideoManager';
import GEDDomium from '../components/GED/GEDDomium';
import GEDUniverselle from '../components/GED/GEDUniverselle';
import TerritoiresManagement from './TerritoiresManagement';
import ExpertsValidation from '../components/ExpertsValidationAmeliore';
import MessagerieDashboard from '../components/Messagerie/MessagerieDashboard';
import AdminProfileEdit from '../components/ProfileEdit/AdminProfileEdit';
import TemplatesCOOPERSManagement from './TemplatesCOOPERSManagement';
import TemplatesExpertsManagement from './TemplatesExpertsManagement';
import ConfigurationGlobale from '../components/ConfigurationGlobale';
import RCDSSouscriptionsDashboard from '../components/RCDSSouscriptionsDashboard';
import DOSDomiumDashboard from '../components/DOSDomiumDashboard';
import GestionCoopersAmeliore from '../components/GestionCoopersAmeliore';
import StatistiquesAvancees from '../components/StatistiquesAvancees';
import GestionConventions from '../components/GestionConventions';
import GestionAdhesions from '../components/GestionAdhesions';
import RechercheUnifiee from '../components/RechercheUnifiee';
import GestionAdmins from '../components/GestionAdmins';
import GestionModeles from '../components/GestionModeles';
import ValidationVirementsESS from '../components/ValidationVirementsESS';
import CooperMembresManagement from '../components/CooperMembresManagement';
import FTPEStatsDashboard from '../components/FTPEStatsDashboard';
import SimulateurDOS from '../components/SimulateurDOS';
import DeclarationDommage from '../components/DeclarationDommage';
import FrontOfficePlansPanel from '../components/FrontOfficePlansPanel';
import NewsletterPanel from '../components/NewsletterPanel';
import LegalcoopAnalyticsPanel from '../components/LegalcoopAnalyticsPanel';
import JuristeDashboardPanel from '../components/JuristeDashboardPanel';
import OrganizationsManagementPanel from '../components/OrganizationsManagementPanel';
import SuperAdminCommunityplacePanel from '../components/SuperAdminCommunityplacePanel';
import CapBatiAttestationsPanel from '../components/CapBatiAttestationsPanel';
import { CoopersOldTab, ConfigOldTab } from './AdminDashboardLegacyTabs';

export default function AdminDashboardTabs({
  activeTab, user, getAuthHeader, isSuperAdmin, t, navigate,
  coopers, handleValidateCooper,
}) {
  return (
    <>
      {activeTab === 'gestion-membres-cooper' && <GestionMembresCooper />}

      {activeTab === 'creation-membres' && <AdminMembresCreation userRole="admin" />}

      {activeTab === 'mes-membres-admin' && <CooperMembresManagement />}



      {activeTab === 'nettoyage-zero' && <NettoyageZeroPanel />}

      {activeTab === 'achats-attente' && <AchatsEnAttente />}

      {activeTab === 'simulateur' && (
        <Card className="border-l-4 border-l-coppam-gold">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-coppam-blue">
              <Calculator className="h-6 w-6 text-coppam-gold" />
              Simulateur Garantie Solidaire BATICO
            </CardTitle>
            <CardDescription>
              Outil d'administration et de simulation Cadre RCDS BATICO
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="bg-gradient-to-r from-slate-700 to-slate-900 rounded-xl p-6 text-white">
              <h3 className="text-xl font-bold mb-2">🧮 Outil Administrateur</h3>
              <p className="text-slate-300 mb-4">
                Accédez au simulateur Cadre RCDS BATICO pour simuler les contributions et accompagner les membres.
              </p>
              <div className="flex flex-wrap gap-3">
                <a href="/calculateur-batico" target="_blank" rel="noopener noreferrer">
                  <Button className="bg-coppam-gold hover:bg-yellow-500 text-slate-900 font-semibold">
                    <Calculator className="h-4 w-4 mr-2" />
                    Nouvelle Souscription
                  </Button>
                </a>
                <a href="/calculateur-batico?mode=avenant" target="_blank" rel="noopener noreferrer">
                  <Button className="bg-white hover:bg-gray-100 text-slate-700 font-semibold">
                    <FilePlus className="h-4 w-4 mr-2" />
                    Créer un Avenant
                  </Button>
                </a>
              </div>
            </div>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-4 gap-4 text-center">
              <div className="p-4 bg-slate-50 rounded-lg">
                <div className="text-2xl mb-2">⚙️</div>
                <p className="text-sm text-slate-600">{t('admin_dashboard.advanced_admin', 'Administration avancée')}</p>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg">
                <div className="text-2xl mb-2">📈</div>
                <p className="text-sm text-slate-600">{t('admin_dashboard.complete_stats', 'Statistiques complètes')}</p>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg">
                <div className="text-2xl mb-2">🔧</div>
                <p className="text-sm text-slate-600">{t('admin_dashboard.settings', 'Paramétrage')}</p>
              </div>
              <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
                <div className="text-2xl mb-2">📝</div>
                <p className="text-sm text-purple-700 font-medium">Avenants</p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {activeTab === 'simulateur-dos-v12' && <SimulateurDOS userRole="admin" />}

      {activeTab === 'declaration-dommage' && <DeclarationDommage />}

      {activeTab === 'gestion' && (
        <Card>
          <CardHeader>
            <CardTitle>{t('admin_dashboard.complete_management', 'Interface de Gestion Complète')}</CardTitle>
            <CardDescription>
              Accédez à l'interface unifiée de gestion de la plateforme
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center py-4 md:py-8">
              <Shield className="h-16 w-16 mx-auto mb-4 text-blue-600" />
              <p className="text-gray-600 mb-6">
                Gérez tous les aspects de la plateforme depuis une interface centralisée
              </p>
              <Button
                size="lg"
                onClick={() => window.location.href = '/admin/gestion'}
                className="bg-blue-600 hover:bg-blue-700"
              >
                <Settings className="h-5 w-5 mr-2" />
                Ouvrir l'Interface de Gestion
              </Button>
              <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <Users className="h-6 w-6 mx-auto mb-2 text-gray-600" />
                  <div className="font-semibold">{t('admin_dashboard.users', 'Utilisateurs')}</div>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <DollarSign className="h-6 w-6 mx-auto mb-2 text-gray-600" />
                  <div className="font-semibold">{t('admin_dashboard.payments', 'Paiements')}</div>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <FileText className="h-6 w-6 mx-auto mb-2 text-gray-600" />
                  <div className="font-semibold">{t('admin_dashboard.devices', 'Dispositifs')}</div>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <TrendingUp className="h-6 w-6 mx-auto mb-2 text-gray-600" />
                  <div className="font-semibold">{t('admin_dashboard.statistics', 'Statistiques')}</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {activeTab === 'conventions' && <GestionConventions />}

      {activeTab === 'modeles-documents' && <GestionModeles getAuthHeader={getAuthHeader} userRole="admin" />}

      {activeTab === 'statistiques' && <StatistiquesAvancees />}

      {activeTab === 'ftpe-stats' && <FTPEStatsDashboard />}

      {activeTab === 'coopers' && <GestionCoopersAmeliore />}

      {activeTab === 'coopers-old' && (
        <CoopersOldTab coopers={coopers} handleValidateCooper={handleValidateCooper} t={t} />
      )}

      {activeTab === 'adhesions' && <GestionAdhesions />}

      {activeTab === 'recherche' && <RechercheUnifiee />}

      {activeTab === 'messagerie' && <MessagerieDashboard />}

      {activeTab === 'experts-validation' && <ExpertsValidation />}

      {activeTab === 'souscriptions-validation' && <><PreuvesVirementAdmin /><SouscriptionsValidation /></>}

      {activeTab === 'sepa-rcd' && <SepaCbPanel />}

      {activeTab === 'virements-ess' && <ValidationVirementsESS />}

      {activeTab === 'suivi-rcds' && (
        <RCDSSouscriptionsDashboard getAuthHeader={getAuthHeader} userRole="admin" />
      )}

      {activeTab === 'suivi-dos-domium' && (
        <DOSDomiumDashboard getAuthHeader={getAuthHeader} userRole="admin" />
      )}

      {activeTab === 'souscriptions-liste' && <SouscriptionsListe />}

      {activeTab === 'dispositifs' && <GestionDispositifs />}

      {activeTab === 'ged' && isSuperAdmin && (
        <div className="space-y-6">
          <GEDDossiers />
          <GEDUniverselle />
          <GEDESS userRole="admin" />
          <GEDDomium />
        </div>
      )}

      {activeTab === 'videos' && (
        <VideoManager userRole="admin" showUpload={true} showDelete={true} />
      )}

      {activeTab === 'collections' && <NomenclatureCollectionsManagement />}

      {activeTab === 'categories' && <CategoriesManagement />}

      {activeTab === 'nomenclature' && <NomenclatureManagement />}
      {activeTab === 'activites-textes' && <ActivitesACompleter />}
      {activeTab === 'envois-attestations-mo' && <EnvoisAttestationsMO />}
      {activeTab === 'derogations-ftpe' && <DerogationsFtpe />}
      {activeTab === 'suivi-signatures' && <SuiviSignatures />}

      {activeTab === 'simulateurs' && <EstimateursManagement />}

      {activeTab === 'parametres-batico' && <ParametresBATICO />}

      {activeTab === 'territoires' && <TerritoiresManagement getAuthHeader={getAuthHeader} />}

      {activeTab === 'templates-coopers' && (
        <TemplatesCOOPERSManagement userId={user.id} getAuthHeader={getAuthHeader} />
      )}

      {activeTab === 'templates-experts' && (
        <TemplatesExpertsManagement getAuthHeader={getAuthHeader} />
      )}

      {activeTab === 'profil' && (
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('admin_dashboard.my_profile', 'Mon Profil')}</h2>
          <AdminProfileEdit admin={user} onUpdate={() => {}} getAuthHeader={getAuthHeader} />
        </div>
      )}

      {activeTab === 'gestion-admins' && isSuperAdmin && <GestionAdmins />}

      {activeTab === 'frontoffice-plans' && isSuperAdmin && <FrontOfficePlansPanel />}

      {activeTab === 'organizations' && isSuperAdmin && <OrganizationsManagementPanel />}

      {activeTab === 'newsletter' && isSuperAdmin && <NewsletterPanel />}

      {activeTab === 'legalcoop-analytics' && isSuperAdmin && <LegalcoopAnalyticsPanel />}

      {activeTab === 'juriste-dashboard' && isSuperAdmin && <JuristeDashboardPanel />}

      {activeTab === 'communityplace-admin' && isSuperAdmin && <SuperAdminCommunityplacePanel />}

      {activeTab === 'cap-bati-attestations' && isSuperAdmin && <CapBatiAttestationsPanel />}

      {/* V38.14 — Raccourci vers le simulateur CAP BATI+ CMI */}
      {activeTab === 'cap-bati-plus-cmi' && (
        <div className="space-y-4" data-testid="admin-cap-bati-shortcut">
          <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
            🏗️ Simulateur CAP BATI+ CMI
          </h2>
          <p className="text-gray-600">
            Estimez la cotisation CAP BATI+ CMI + Option GFA + contributions
            FOGEDOM/SCIC et Expertise préventive (9,50 % chacune) sur les
            contrats de construction de maison individuelle.
          </p>
          <a
            href="/simulateurs/cap-bati-plus-cmi"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="admin-open-cap-bati-simulator"
            className="inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-semibold shadow-lg transition-colors"
          >
            Ouvrir le simulateur →
          </a>
        </div>
      )}

      {activeTab === 'super-admin' && isSuperAdmin && (
        <div>
          <Card className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white border-0 shadow-lg mb-6">
            <CardContent className="pt-6">
              <div className="flex items-center gap-4">
                <Crown className="h-12 w-12" />
                <div>
                  <h2 className="text-2xl font-bold">{t('admin_dashboard.super_admin_dashboard', 'Super Admin Dashboard')}</h2>
                  <p>{t('admin_dashboard.assignments_permissions', 'Gestion des assignations et permissions')}</p>
                </div>
              </div>
            </CardContent>
          </Card>
          <Button
            onClick={() => navigate('/admin/super-dashboard')}
            className="bg-gradient-to-r from-yellow-500 to-orange-600 hover:from-yellow-600 hover:to-orange-700"
            size="lg"
          >
            <Crown className="h-5 w-5 mr-2" />
            Accéder au Dashboard Super Admin
          </Button>
          {/* V37.50 — Cockpit CCMI */}
          <Button
            onClick={() => navigate('/admin/ccmi-dashboard')}
            className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 ml-2"
            size="lg"
            data-testid="open-ccmi-dashboard-btn"
          >
            <Building2 className="h-5 w-5 mr-2" />
            Cockpit CCMI
          </Button>
        </div>
      )}

      {activeTab === 'config' && <ConfigurationGlobale />}

      {activeTab === 'config-old' && <ConfigOldTab t={t} />}
    </>
  );
}
